export const selectCurrencyData = (state) => state.currency.data;
export const selectCurrencyLoading = (state) => state.currency.loading;
export const selectCurrencyError = (state) => state.currency.error;
export const selectCurrencyLastFetched = (state) => state.currency.lastFetched;
